import React, { Fragment , } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AppOutlineButton from "components/ui/AppOutlineButton";
import { UTILS } from "utils";
import { useGetCitiesMutation, useGetCityAreasMutation, useSendOrderToIfastMutation } from "redux/Logistic/IfastService";
import { LoaderAction } from "redux/actions";
import { ifnullOrUndefined } from "utils/Utils";

const CreateClaim = (props) => {

  const { t } = useTranslation();
  const { orderInfo } = useSelector((state) => state?.LogisticReducer);
  const [getCities]= useGetCitiesMutation()
  const [getCityAreas]= useGetCityAreasMutation()
  const [sendOrderToIfast]= useSendOrderToIfastMutation()
  const dispatch= useDispatch()

  const sendOrder= async ()=>{
    try{
      const result= await sendOrderToIfast({orderId:orderInfo._id})
      if(result?.data){
        UTILS.successNotification(t("Order placed successfully"));
      }
      await props.fetchOrderDetailsByID();

    }catch(e){
      UTILS.errorNotification(t(e));
    }finally {
      dispatch(LoaderAction.setLoading(false));
    }
  }
  const getIfastCityAreas= async (cityId)=>{
    try{
      const result=await getCityAreas({cityId})
      const areas=result.data.data.flat()
      if(areas){
        const selectedArea= areas.find(d=>d.name.toLowerCase()==orderInfo.deliveryAddress.area.toLowerCase())
        if(!selectedArea){
          UTILS.errorNotification(t('Ifast service not available in selected area'));
             dispatch(LoaderAction.setLoading(false));
        }else{
          sendOrder()
        }
      }
    }catch(e){
      UTILS.errorNotification(t(e));
         dispatch(LoaderAction.setLoading(false));
    }
  }

  const checkCitiesAreaAndPlaceorder= async ()=>{
    try{
      dispatch(LoaderAction.setLoading(true));
      const result= await getCities()
      if(result.data){
        const city = orderInfo?.deliveryAddress?.city?.toLowerCase();
        const selectedCity = result?.data?.data?.find(
          d =>
            city === d?.name?.toLowerCase() ||
            city === d?.name_Arabic?.toLowerCase()
        );
        if(selectedCity){
          await getIfastCityAreas(selectedCity.city_ID)
        }else{
          UTILS.errorNotification(t('Ifast service not available in selected city'));
          dispatch(LoaderAction.setLoading(false));
        }
      }
    }catch(e){
      UTILS.errorNotification(t(e));
      dispatch(LoaderAction.setLoading(false));
    }
  }

  

  const allowSendOrderToIfast = () => {
    if (ifnullOrUndefined(orderInfo?.logisticPartnerMetadata?.IFAST?.createDeliveryResponse)){
      return true;
    }else if(orderInfo?.logisticPartnerMetadata?.IFAST?.deliveryStatus ==="Cancelled") {
      return true;
    }else{
      return false;
    }
  };

  return (
    <Fragment key={props?.customKey}>
      <div className="flex flex-col justify-center items-center">
        <>
          <div className="ml-4 py-4 text-center" >
            {allowSendOrderToIfast() ? (
              <AppOutlineButton
                type="default"
                size="large"
                onClick={checkCitiesAreaAndPlaceorder}
                className="w-56  my-2 rounded-md font-semibold"
              >
                {t("Send order to iFast")}
              </AppOutlineButton>
            ) : (
              <div>
                <span className="text-sm text-gray-500">
                  {t(
                    "Your order has been sent to IFast for delivery. Please check the ORDER DETAIL tab for Rider details"
                  )}
                </span>
              </div>
            )}
          </div>
        </>
      </div>
    </Fragment>
  );
};

export default CreateClaim;
